export const queryCrmContacts = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: '/api/crm-contact/query',
    data,
    signal,
  });

export const previewSavedCrmGroup = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: '/api/crm-contact/preview-saved-crm-group',
    data,
    signal,
  });
